// TimePanel.tsx
import * as React from 'react';

type TimePanelProps = {
	value?: Date;
	onChange: (date: Date) => void;
};

export function TimePanel({ value, onChange }: TimePanelProps) {
	return (
		<div className="flex gap-2 items-center grid grid-cols-2">
			{/* Heure */}
			<label>
				Heure:
				<input
					type="number"
					min={0}
					max={23}
					value={value?.getHours() ?? 12}
					onChange={(e) => {
						if (!value) return;
						const d = new Date(value);
						d.setHours(Number(e.target.value));
						onChange(d);
					}}
					className="ml-2 w-16 border rounded p-1"
				/>
			</label>

			{/* Minutes */}
			<label>
				Minutes:
				<input
					type="number"
					min={0}
					max={59}
					value={value?.getMinutes() ?? 0}
					onChange={(e) => {
						if (!value) return;
						const d = new Date(value);
						d.setMinutes(Number(e.target.value));
						onChange(d);
					}}
					className="ml-2 w-16 border rounded p-1"
				/>
			</label>
		</div>
	);
}
